import { createAsyncThunk } from "@reduxjs/toolkit";
import toastHelper from "../../Util/toastHelper";
import API from "../../API/API";
import axios from "axios";

export const getAllUsers = createAsyncThunk(
  "buildings/getAllUsers",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllUsers.url,
        method: API.admin.getAllUsers.method,
      });

      return data?.users;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const addUser = createAsyncThunk(
  "users/addUser",
  async (
    params: {
      emailAddress: string;
      firstName: string;
      lastName: string;
      roleId: number;
      isActive: boolean;
      password: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.addUser.url,
        method: API.admin.addUser.method,
        data: params,
      });
      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAllRoles = createAsyncThunk(
  "users/getAllRoles",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllRoles.url,
        method: API.admin.getAllRoles.method,
      });

      return data?.roles;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getUserById = createAsyncThunk(
  "users/getUserById",
  async (id: number, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getUserById.url + id,
        method: API.admin.getUserById.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const editUser = createAsyncThunk(
  "users/editUser",
  async (
    params: {
      userId: number;
      emailAddress: string;
      firstName: string;
      lastName: string;
      roleId: number;
      isActive: boolean;
      password: string;
      confirmPassword: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.editUser.url,
        method: API.admin.editUser.method,
        data: params,
      });

      params.successHandler();

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (
    params: {
      id: number;
      successHandler: () => void;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.deleteUser.url + params?.id,
        method: API.admin.deleteUser.method,
      });

      params.successHandler();
      dispatch(getAllUsers());

      toastHelper.success(data?.message);

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const clearGetAllUsers = createAsyncThunk(
  "users/clearGetAllUsers",
  async (_, { rejectWithValue }) => {
    return null;
  },
);

export const clearGetUserById = createAsyncThunk(
  "users/clearGetUserById",
  async (_, { rejectWithValue }) => {
    return null;
  },
);
